import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5666d6ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-column" }
const _hoisted_2 = {
  key: 1,
  class: "list-column__text"
}


import ListHeader from "./ListHeader.vue";
import ListText from "./ListText.vue";

interface IProps {
  header: string;
  text?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ListColumn',
  props: {
    header: {},
    text: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ListHeader, {
      text: _ctx.header,
      class: "list-column__header"
    }, null, 8, ["text"]),
    (_ctx.text)
      ? (_openBlock(), _createBlock(ListText, {
          key: 0,
          text: _ctx.text,
          class: "list-column__text"
        }, null, 8, ["text"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ]))
  ]))
}
}

})